import { FC } from 'react';

import { IconProps } from '.';

export const ColumnConfigIcon: FC<IconProps> = ({
  width = 16,
  height = 16,
  color = '#171717',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.20069 1.33358C4.08057 1.33358 3.42678 1.29911 2.78926 1.62394C2.28757 1.87956 1.87954 2.2876 1.62394 2.78926C1.29911 3.42677 1.33358 4.08057 1.33358 5.20069V10.7996C1.33358 11.9197 1.29914 12.5735 1.62394 13.211C1.87956 13.7127 2.28761 14.1207 2.78926 14.3763C3.42677 14.7012 4.08057 14.6667 5.20069 14.6667H10.7996C11.9197 14.6667 12.5735 14.7011 13.211 14.3763C13.7127 14.1207 14.1207 13.7127 14.3763 13.211C14.7011 12.5735 14.6667 11.9197 14.6667 10.7996V5.20069C14.6667 4.08057 14.7012 3.42678 14.3763 2.78926C14.1207 2.28758 13.7127 1.87954 13.211 1.62394C12.5735 1.29915 11.9197 1.33358 10.7996 1.33358H6.00015H5.20069ZM5.20069 2.66689H5.33351V13.3334H5.20069C4.08057 13.3334 3.61285 13.2987 3.39472 13.1876C3.14375 13.0597 2.94056 12.8565 2.81269 12.6056C2.70151 12.3874 2.66686 11.9197 2.66686 10.7996V5.20073C2.66686 4.08061 2.70155 3.61288 2.81269 3.39475C2.94056 3.14379 3.14376 2.9406 3.39472 2.81272C3.61283 2.70159 4.08057 2.66689 5.20069 2.66689ZM6.66681 2.66689H9.33344V13.3334H6.66681V2.66689ZM10.6668 2.66689H10.7996C11.9197 2.66689 12.3874 2.70155 12.6055 2.81272C12.8565 2.94059 13.0597 3.14379 13.1876 3.39475C13.2987 3.61286 13.3334 4.08061 13.3334 5.20073V10.7996C13.3334 11.9197 13.2988 12.3874 13.1876 12.6056C13.0597 12.8565 12.8565 13.0597 12.6055 13.1876C12.3873 13.2988 11.9197 13.3334 10.7996 13.3334H10.6668V2.66689Z"
      fill={color}
    />
  </svg>
);
